"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _lodash = require("lodash");

var _blockEditor = require("@wordpress/block-editor");

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    width,
    content,
    columns
  } = attributes;
  return (0, _element.createElement)("div", _blockEditor.useBlockProps.save({
    className: `align${width} columns-${columns}`
  }), (0, _lodash.times)(columns, index => (0, _element.createElement)("div", {
    className: "wp-block-column",
    key: `column-${index}`
  }, (0, _element.createElement)(_blockEditor.RichText.Content, {
    tagName: "p",
    value: (0, _lodash.get)(content, [index, 'children'])
  }))));
}
//# sourceMappingURL=save.js.map